export function weekdayLabel(date, locale = "ru-RU") {
  return new Intl.DateTimeFormat(locale, { weekday: "long" }).format(date)
}

export function tickCountdown(remaining) {
  const next = remaining - 1
  return { remaining: next > 0 ? next : 0, finished: next <= 0 }
}

export function advanceTask(index, total) {
  if (index + 1 >= total) return { index, done: true }
  return { index: index + 1, done: false }
}
